import { useEffect, useRef } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useMe } from "@/lib/api";
import { useCheckout } from "@/lib/useCheckout";

const ALLOWED = ["monthly", "yearly", "team_monthly", "team_yearly", "firm5_monthly", "firm5_yearly"];
const LABELS = {
  monthly: "Pro Monthly - $9.99/month", yearly: "Pro Yearly - $99.99/year",
  team_monthly: "Team - $9.99/seat/month", team_yearly: "Team - $99.99/seat/year",
  firm5_monthly: "Firm (5 seats) - $39.99/month", firm5_yearly: "Firm (5 seats) - $399.99/year",
};

export default function UpgradePage() {
  const [params] = useSearchParams();
  const plan = params.get("plan");
  const { data: me } = useMe();
  const { checkout, ready } = useCheckout();
  const started = useRef(false);
  const valid = ALLOWED.includes(plan);
  const seats = Math.min(100, Math.max(2, parseInt(params.get("seats"), 10) || 2));
  const isTeam = (plan || "").startsWith("team");

  useEffect(() => {
    if (!valid || !ready || !me || me.usage.plan === "pro" || started.current) return;
    started.current = true;
    checkout(plan, isTeam ? { seats } : {});
  }, [valid, ready, me, plan, checkout, isTeam, seats]);

  if (!valid || me?.usage?.plan === "pro") return <Navigate to={valid ? "/" : "/pricing"} replace />;
  return (
    <main className="max-w-md mx-auto px-4 py-24 text-center" data-testid="upgrade-page">
      <Loader2 className="animate-spin mx-auto text-blue-600" size={32} />
      <h1 className="font-heading text-2xl font-bold mt-4">Taking you to secure checkout...</h1>
      <p className="text-slate-600 mt-2" data-testid="upgrade-plan-label">{LABELS[plan]}{isTeam ? ` x ${seats} seats` : ""}</p>
    </main>
  );
}
